const borders = {
    solidBorder: '1px solid'
};

export { borders as default };
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYm9yZGVycy5qcyIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL3RoZW1lL2JvcmRlcnMudHMiXSwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0IGludGVyZmFjZSBCb3JkZXJzIHtcbiAgc29saWRCb3JkZXI6IHN0cmluZztcbiAgW2JvcmRlclN0eWxlOiBzdHJpbmddOiBzdHJpbmc7XG59XG5cbmNvbnN0IGJvcmRlcnM6IEJvcmRlcnMgPSB7XG4gIHNvbGlkQm9yZGVyOiAnMXB4IHNvbGlkJ1xufTtcblxuZXhwb3J0IGRlZmF1bHQgYm9yZGVycztcbiJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFLQSxNQUFNLE9BQU8sR0FBWTtBQUN2QixJQUFBLFdBQVcsRUFBRTs7Ozs7In0=
